import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { EOtpremnicaDropdownDto, EOtpremniceClient, TipDokumentaOtpremnica } from '@kodit/core/data-api';
import { AbstractControl, FormArray } from '@angular/forms';
import { LocationService } from '@kodit/core/services';

@Component({
  selector: 'kodit-eotpremnica-multiselect',
  templateUrl: './eotpremnica-multiselect.component.html',
  styleUrls: ['./eotpremnica-multiselect.component.scss'],
})
export class EotpremnicaMultiselectComponent implements OnInit {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[];
  selectedItems: EOtpremnicaDropdownDto[] = [];

  /** I/O */
  @Input() otpremniceArray: FormArray | AbstractControl;
  @Input() racunId: number = null;
  @Input() tipDokumentaOtpremnica: TipDokumentaOtpremnica = TipDokumentaOtpremnica.OTPREMNICA;
  @Output() selectedOtpremnice = new EventEmitter<EOtpremnicaDropdownDto[]>();

  constructor(
    private _client: EOtpremniceClient,
    private _locationService: LocationService
  ) {}

  ngOnInit(): void {
    this._load();
  }

  private _load() {
    this.selectedItems = [...this.otpremniceArray.value.map((x) => x)];

    this._subs.add(
      this._client.getEotpremniceDropdown(this.tipDokumentaOtpremnica, this.racunId).subscribe((res) => {
        if (res.data?.length > 0) {
          this.items = res.data.map((x) => ({
            value: x,
            label: x.broj,
          }));
        } else {
          this.items = [];
        }
      })
    );
  }

  selectedItemsOnChange() {
    this.selectedOtpremnice.next(this.selectedItems);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
